// Textbausteine (Phase 2.A): Popover im Editor, geöffnet per Knopf oder `/` am Zeilenanfang.
// Die Texte kommen fertig gefüllt von der API (CRM-Werte des Threads), Lücken stehen als [PRÜFEN: …].
import { useEffect, useRef, useState } from 'react';
import { api, type BausteinRow } from '../lib/api.ts';

export function BausteinePopover({
  threadId,
  onPick,
  onClose,
}: {
  threadId: number | null;
  onPick: (b: BausteinRow) => void;
  onClose: () => void;
}) {
  const [list, setList] = useState<BausteinRow[] | null>(null);
  const [q, setQ] = useState('');
  const [sel, setSel] = useState(0);
  const inp = useRef<HTMLInputElement>(null);
  useEffect(() => {
    void api.bausteine(threadId).then((r) => setList(r.bausteine));
    inp.current?.focus();
  }, [threadId]);
  const treffer = (list ?? []).filter((b) => {
    const s = q.trim().toLowerCase().replace(/^\//, '');
    return (
      !s ||
      b.key.includes(s) ||
      b.titel.toLowerCase().includes(s) ||
      b.gruppe.toLowerCase().includes(s)
    );
  });
  const pick = (b: BausteinRow | undefined) => {
    if (b) onPick(b);
  };
  return (
    <div className="bs-pop" role="dialog" aria-label="Textbausteine">
      <input
        ref={inp}
        className="bs-q"
        placeholder="Baustein suchen … (Esc schließt)"
        value={q}
        onChange={(e) => {
          setQ(e.target.value);
          setSel(0);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onClose();
          else if (e.key === 'ArrowDown') setSel((s) => Math.min(s + 1, treffer.length - 1));
          else if (e.key === 'ArrowUp') setSel((s) => Math.max(s - 1, 0));
          else if (e.key === 'Enter') pick(treffer[sel]);
        }}
      />
      <div className="bs-list">
        {!list && <div className="muted">lädt …</div>}
        {list && treffer.length === 0 && <div className="muted">Kein Baustein passt.</div>}
        {treffer.map((b, i) => (
          <button
            key={b.key}
            className={`bs-item${i === sel ? ' on' : ''}`}
            onMouseEnter={() => setSel(i)}
            onClick={() => pick(b)}
            title={b.text}
          >
            <span className="bs-key">/{b.key}</span>
            <span className="bs-title">{b.titel}</span>
            <span className="bs-grp">{b.gruppe}</span>
            {b.pruefen > 0 && <span className="pill warn">{b.pruefen} PRÜFEN</span>}
          </button>
        ))}
      </div>
      <div className="bs-foot muted">
        Platzhalter wie Schule, Termin und ALL-IN-Preis sind aus dem CRM gefüllt; was fehlt, steht
        als [PRÜFEN].
      </div>
    </div>
  );
}
